import moment from "moment";
// import moment from "moment/moment";

export const formatDateForAPI = (
  date: Date | string,
  time: string | null = null,
) => {
  if (!date) return null;

  const format = time ? "YYYY-MM-DDT" + time : "YYYY-MM-DDTHH:mm:ss";

  // Parse the date and format it, ensuring we keep the local timezone values
  // moment() will parse the date in local timezone by default
  return moment(date).format(format);
};
